// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 590 ? "main" : chunkId) + "." + {"380":"cf514b85575b38bb095b","590":"ad762350a2b85195612c"}[chunkId] + ".css";
};